import type { RideApiStop } from "@/types/rideDetails";

const PICKUP_STOP_TYPES = new Set(["START", "PICKUP", "ENROUTE"]);
const DROPOFF_STOP_TYPES = new Set(["ENROUTE", "DROP", "END"]);

/** Pin colors — start/end differ from intermediate pickup/drop stops. */
export const PIN_COLORS = {
  start: "#10b981",
  end: "#ef4444",
  pickup: "#2563eb",
  drop: "#ea580c",
  enroute: "#7c3aed",
} as const;

export function getStopPinColor(stop: RideApiStop): string {
  const type = stop.stoptype?.toUpperCase() ?? "";
  switch (type) {
    case "START":
      return PIN_COLORS.start;
    case "END":
      return PIN_COLORS.end;
    case "PICKUP":
      return PIN_COLORS.pickup;
    case "DROP":
      return PIN_COLORS.drop;
    case "ENROUTE":
      return PIN_COLORS.enroute;
    default:
      return PIN_COLORS.enroute;
  }
}

export function getPickupStops(stops: RideApiStop[]): RideApiStop[] {
  return stops.filter(
    (s) => s.stoptype != null && PICKUP_STOP_TYPES.has(s.stoptype.toUpperCase())
  );
}

/** All drop-off category stops (optionally excluding a selected pickup stop id). */
export function getDropoffStops(
  stops: RideApiStop[],
  excludeStopId?: number
): RideApiStop[] {
  return stops.filter(
    (s) =>
      s.stoptype != null &&
      DROPOFF_STOP_TYPES.has(s.stoptype.toUpperCase()) &&
      s.stopid !== excludeStopId
  );
}

export function stopDisplayLabel(stop: RideApiStop): string {
  return stop.sl || stop.sc || `Stop ${stop.stopid ?? ""}`;
}

export function stopToMapPoint(
  stop: RideApiStop
): { lat: number; lng: number; label: string; color: string } | null {
  if (typeof stop.lat !== "number" || typeof stop.lng !== "number") return null;
  return {
    lat: stop.lat,
    lng: stop.lng,
    label: stopDisplayLabel(stop),
    color: getStopPinColor(stop),
  };
}
